import React, { useCallback } from 'react'
import styles from './style.module.scss'
import { useRouter } from 'next/router'

const XHeader = () => {
    const router = useRouter()

    console.log(window.PERSON)
    const urlFragment = (
        window.PERSON?.applicationDetails[0].program?.urlFragment || window.PROGRAM.urlFragment
    ).replace('/', '')

    const onClickReturnHome = useCallback(() => {
        window.location.href = `/${urlFragment}`
    }, [router])

    return (
        <header className={styles.header}>
            <div className={styles.header__logo} onClick={onClickReturnHome}></div>
        </header>
    )
}

XHeader.displayName = 'Header'

export default XHeader
